<div>
  <app-header [title]="'menu.RETAIL.retail-rewards' | translate" [showRewardsLogo]="true" />

  <!-- Contenedor limitado y centrado -->
  <div class="max-w-screen-xl mx-auto px-2 py-6 bg-gray-50 flex flex-col gap-6">

    <ng-container *ngIf="this.canExchangePoints">
    <!-- Grid de 3 columnas para los 3 bloques principales -->
    <div class="grid grid-cols-1 lg:grid-cols-3 gap-8">
      <!-- Panel de Registro y Nivel -->
      <div class="flex flex-col bg-white p-4 gap-2">
        <span class="typography-title-m">
          {{ 'myrewards.title_register_rewards' | translate }}
        </span>
        <span class="typography-body-l-regular textSecondary-color mb-2">
          {{ 'myrewards.description_register_rewards' | translate }}
        </span>
        <app-button [primary]="true" (onClick)="goToRegisterSales()" class="w-full" size="l">
          {{ 'myrewards.button_register_sale' | translate }}
        </app-button>
        <div
          class="mt-1 p-3 flex flex-row"
          [ngStyle]="{
            'background': 'url(https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/loyalty/' + this.currentStatus.toLowerCase() + '/background-desktop.png)',
            'background-size': 'cover',
            'color': 'white'
          }"
        >
          <div style="width: 50%">
            <p class="typography-body-m-medium textInverse-color">
              {{ 'myrewards.text_your_level' | translate }}:
              <span class="font-semibold">{{this.currentStatus}}</span>
            </p>
            <div class="flex flex-col">
              <span class="typography-title-xxl textInverse-color">{{this.currentSales()}}</span>
              <span>{{ 'myrewards.text_sales_registered' | translate }}</span>
            </div>
          </div>
          <p class="typography-body-m-medium textInverse-color mt-auto ms-auto" style="width: 50%">
            {{this.progressText}}
          </p>
        </div>
      </div>

      <!-- Panel de Puntos e Info -->
      <div class="grid grid-cols-1 lg:grid-cols-2 lg:col-span-2">
        <!-- Panel de Puntos ADVANCED -->
        <div *ngIf="currentStatus === 'ADVANCED'"  class="bg-white p-4 lg:border-r lg:border-[color:var(--Specific-Divider-Divider,#A9AEBC)] flex-col flex gap-4">
          <app-cosentino-svg class="icon" [svgName]="'overall-actios'" [size]="32" style="color: var(--primaryActive)"></app-cosentino-svg>
          <div class="typography-title-m mt-0">{{ 'myrewards.title_upgrade_to_elite' | translate }}</div>
          <app-button *ngIf="canExchangePoints" [secondary]="true" size="L" class="w-full mt-auto" iconPosition="end" (onClick)="goToRewardsProvider()">
            {{ 'myrewards.link_discover' | translate }}
          </app-button>
        </div>
        <!-- Panel de Puntos ELITE / PREMIUM -->
        <div *ngIf="currentStatus !== 'ADVANCED'"  class="bg-white p-4 lg:border-r lg:border-[color:var(--Specific-Divider-Divider,#A9AEBC)] flex-col flex justify-between">
          <app-cosentino-svg class="icon" [svgName]="'overall-actios'" [size]="32" style="color: var(--primaryActive)"></app-cosentino-svg>
          <div>
            <div class="typography-title-m ">{{ 'myrewards.title_my_points' | translate }}</div>          
            <div class="typography-body-s-regular textTerciary-color">{{ 'myrewards.global_position_as_of' | translate }} {{ getFormattedDate() }}</div>
          </div>
          <div class="bg-background-light-01 p-4 mb-4">
            <h2 class="typography-body-l-regular">{{ 'myrewards.total_available_points' | translate }}</h2>
            <span class="typography-title-xxl">{{this.availableActios}}</span>
            <app-link *ngIf="canExchangePoints" (onClick)="goToRewardsProvider()" [contentClass]="'text-primary no-underline'" class="typography-body-m-light text-text-primary">
              {{ 'myrewards.link_redeem_points' | translate }}
            </app-link>
          </div>
          <app-button [secondary]="true" size="L" class="w-full" (onClick)="goToMyPoints()">
            {{ 'myrewards.link_view_details' | translate }}
          </app-button>
        </div>

        <!-- Info de los puntos -->
        <div class="bg-white p-4 flex flex-col gap-4">
          <app-cosentino-svg class="icon" [svgName]="'info'" [size]="32" style="color: var(--primaryActive)"></app-cosentino-svg>
          <span class="typography-title-m">
            {{ 'myrewards.title_what_are_points' | translate }}
          </span>
          <p class="typography-body-l-regular">
            {{ 'myrewards.description_what_are_points' | translate }}
          </p>
          <app-button *ngIf="!isLoyalty2026Active" [ghost]="true" size="L" class="w-full mt-auto" (onClick)="knowYourBenefits()">
            {{ 'myrewards.link_know_your_benefits' | translate }}
          </app-button>
          <app-button *ngIf="isLoyalty2026Active" [ghost]="true" size="L" class="w-full mt-auto" [showIcon]="true" iconType="arrow" iconPosition="end" (onClick)="gotoBBenefits()">
            {{ 'myrewards.link_know_your_benefits' | translate }}
          </app-button>
        </div>
      </div>
    </div>

    <!-- Banner a ancho completo (fuera del grid anterior) -->
    <!-- <div *ngIf="userInfo?.accountType == 'RETAIL' && userInfo?.country == 'US' && ['ELITE','PREMIUM'].includes(currentStatus)"> -->
    <!-- <div>
      <img
        src="https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/myRewards/Banner_Granite_Gold_1-desktop.jpg"
        alt="Banner"
        class="w-full object-cover"
      />
    </div> -->

    <!-- Sección de Recompensas -->
    <div class="grid grid-cols-1 lg:grid-cols-12 gap-8">

      <div class="lg:col-span-12 flex flex-col gap-4"  *ngIf="isLoyalty2026Active">
        <div class="flex flex-row items-center gap-4">
          <span class="typography-body-l-medium">
            {{ 'myrewards.title_reward_categories' | translate }}
          </span>
          <app-link *ngIf="canExchangePoints" (onClick)="goToRewardsProvider()" [contentClass]="'text-primary no-underline'" class="typography-body-s-regular text-text-primary">
              <div class="flex items-center">
              {{ 'myrewards.link_discover_rewards' | translate }}
             <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M9.4002 17.3L8.7002 16.6L13.3002 12L8.7002 7.40001L9.4002 6.70001L14.7002 12L9.4002 17.3Z" fill="#365BCA"/>
                </svg>
              </div>
          </app-link>
          <a *ngIf="rewardsTcUrl" [href]="rewardsTcUrl" target="_blank" rel="noopener noreferrer"
             class="ms-auto flex items-center gap-1 typography-body-s-regular text-text-primary no-underline hover:underline">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" fill="#365BCA"/>
            </svg>
            {{ 'myrewards.link_terms_and_conditions' | translate }}
          </a>
        </div>

        <div class="grid grid-cols-1 sm:grid-cols-4 gap-8">
          <!-- Tarjetas regalo -->
          <div>
            <img
              src="https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/actios/images/giftcard-desktop-2026.jpg"
              alt="{{ 'myrewards.gift_cards' | translate }}"
              class="w-full h-[240px] object-cover"
            />
            <span class="typography-body-m-regular">
              {{ 'myrewards.gift_cards' | translate }}
            </span>
            <app-link *ngIf="canExchangePoints" (onClick)="goToRewardsProvider()" [contentClass]="'text-primary no-underline flex'" class="block mt-1 typography-body-s-regular text-text-primary">
              <div class="flex items-center">
                {{ 'myrewards.link_see_now' | translate }}
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M9.4002 17.3L8.7002 16.6L13.3002 12L8.7002 7.40001L9.4002 6.70001L14.7002 12L9.4002 17.3Z" fill="#365BCA"/>
                </svg>
              </div>
            </app-link>
          </div>

          <!-- Dispositivos -->
          <div>
            <img
              src="https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/actios/images/dispositivos-2026.jpg"
              alt="{{ 'myrewards.devices' | translate }}"
              class="w-full h-[240px] object-cover"
            />
            <span class="typography-body-m-regular">
              {{ 'myrewards.devices' | translate }}
            </span>
            <app-link *ngIf="canExchangePoints" (onClick)="goToRewardsProvider()" [contentClass]="'text-primary no-underline flex'" class="block mt-1 typography-body-s-regular text-text-primary">
              <div class="flex items-center">
                {{ 'myrewards.link_see_now' | translate }}
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M9.4002 17.3L8.7002 16.6L13.3002 12L8.7002 7.40001L9.4002 6.70001L14.7002 12L9.4002 17.3Z" fill="#365BCA"/>
                </svg>
              </div>
            </app-link>
          </div>

          <!-- Caridad -->
          <div>
            <img
              src="https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/actios/images/charity-desktop-2026.png"
              alt="{{ 'myrewards.charity' | translate }}"
              class="w-full h-[240px] object-cover"
            />
            <span class="typography-body-m-regular">
              {{ 'myrewards.charity' | translate }}
            </span>
            <app-link *ngIf="canExchangePoints" (onClick)="goToRewardsProvider()" [contentClass]="'text-primary no-underline flex'" class="block mt-1 typography-body-s-regular text-text-primary">
              <div class="flex items-center">
                {{ 'myrewards.link_see_now' | translate }}
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M9.4002 17.3L8.7002 16.6L13.3002 12L8.7002 7.40001L9.4002 6.70001L14.7002 12L9.4002 17.3Z" fill="#365BCA"/>
                </svg>
              </div>
            </app-link>
          </div>

          <!-- Tarjeta Debito -->
          <div>
            <img
              src="https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/actios/images/debit-card-2026.jpg"
              alt="{{ 'myrewards.debit_card' | translate }}"
              class="w-full h-[240px] object-cover"
            />
            <span class="typography-body-m-regular">
              {{ 'myrewards.debit_card' | translate }}
            </span>
            <app-link *ngIf="canExchangePoints" (onClick)="goToRewardsProvider()" [contentClass]="'text-primary no-underline flex'" class="block mt-1 typography-body-s-regular text-text-primary">
              <div class="flex items-center">
                {{ 'myrewards.link_see_now' | translate }}
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M9.4002 17.3L8.7002 16.6L13.3002 12L8.7002 7.40001L9.4002 6.70001L14.7002 12L9.4002 17.3Z" fill="#365BCA"/>
                </svg>
              </div>
            </app-link>

          </div>
        </div>
      </div>
      <!-- Columna izquierda (categorías): 8 columnas -->
      <div class="lg:col-span-8 flex flex-col gap-6"  *ngIf="!isLoyalty2026Active">
        <div class="flex flex-row items-center gap-4">
          <span class="typography-body-l-medium">
            {{ 'myrewards.title_reward_categories' | translate }}
          </span>
          <app-link *ngIf="canExchangePoints" (onClick)="goToRewardsProvider()" [contentClass]="'text-primary no-underline'" class="typography-body-s-regular text-text-primary">
                      <div class="flex items-center">
                  <div class="link-s">{{ 'myrewards.link_discover_rewards' | translate }}</div>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path
                      d="M6.26647 11.5333L5.7998 11.0667L8.86647 7.99999L5.7998 4.93333L6.26647 4.46666L9.7998 7.99999L6.26647 11.5333Z"
                      fill="#365BCA" />
                  </svg>
                </div>

          </app-link>
          <a *ngIf="rewardsTcUrl" [href]="rewardsTcUrl" target="_blank" rel="noopener noreferrer"
             class="ms-auto flex items-center gap-1 typography-body-s-regular text-text-primary no-underline hover:underline">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" fill="#365BCA"/>
            </svg>
            {{ 'myrewards.link_terms_and_conditions' | translate }}
          </a>
        </div>

        <div class="grid grid-cols-1 sm:grid-cols-3 gap-8">
          <!-- Tarjetas regalo -->
          <div>
            <img
              src="https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/actios/images/giftcard-desktop.png"
              alt="Tarjetas regalo"
              class="w-full h-[240px] object-cover"
            />
            <span class="typography-body-m-regular">
              {{ 'myrewards.gift_cards' | translate }}
            </span>
            <app-link *ngIf="canExchangePoints" (onClick)="goToRewardsProvider()" [contentClass]="'text-primary no-underline'" class="block mt-1 typography-body-s-regular text-text-primary">
              {{ 'myrewards.link_see_now' | translate }}
            </app-link>
          </div>

          <!-- Dispositivos -->
          <div>
            <img
              src="https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/actios/images/merchandise-desktop.png"
              alt="Dispositivos"
              class="w-full h-[240px] object-cover"
            />
            <span class="typography-body-m-regular">
              {{ 'myrewards.devices' | translate }}
            </span>
            <app-link *ngIf="canExchangePoints" (onClick)="goToRewardsProvider()" [contentClass]="'text-primary no-underline'" class="block mt-1 typography-body-s-regular text-text-primary">
              {{ 'myrewards.link_see_now' | translate }}
            </app-link>
          </div>

          <!-- Caridad -->
          <div>
            <img
              src="https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/actios/images/charity-desktop.png"
              alt="Caridad"
              class="w-full h-[240px] object-cover"
            />
            <span class="typography-body-m-regular">
              {{ 'myrewards.charity' | translate }}
            </span>
            <app-link *ngIf="canExchangePoints" (onClick)="goToRewardsProvider()" [contentClass]="'text-primary no-underline'" class="block mt-1 typography-body-s-regular text-text-primary">
              {{ 'myrewards.link_see_now' | translate }} <svg c-cosentinoSvg_chevronRight="" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path c-cosentinoSvg_chevronRight="" class="primaryDefault" d="M9.4002 17.3L8.7002 16.6L13.3002 12L8.7002 7.39995L9.4002 6.69995L14.7002 12L9.4002 17.3Z" fill="#232323"></path></svg>
            </app-link>
          </div>
        </div>
      </div>

      <div class="lg:col-span-4 flex flex-col gap-6"  *ngIf="!isLoyalty2026Active">
            <app-dynamic-banner></app-dynamic-banner>
      </div>
    </div>
    <app-confirm-modal
    [isOpen]="newPointsProviderModal"
    confirmText="{{'common.buttons.close' | translate}}"
    cancelText=""
    (onConfirm)="closeNewPointsModal()"
    (onCancel)="closeNewPointsModal()"
    (onClose)="closeNewPointsModal()"
>
<span class="typography-title-l text-primary">{{ 'myrewards.we_are_improving_for_you' | translate }}</span>
<p class="typography-body-m-light text-center">{{ 'myrewards.new_points_provider_marketplace_phrase_1' | translate }}<br/>
{{ 'myrewards.new_points_provider_marketplace_phrase_2' | translate }}<br/>
{{ 'myrewards.new_points_provider_marketplace_phrase_3' | translate }}</p>
</app-confirm-modal>
    </ng-container>
    <ng-container *ngIf="!this.canExchangePoints">
            <div class="flex flex-col bg-white p-4 gap-2 items-center p-8">
              <span class="text-primary typography-title-l mb-2">{{'myrewards.join_our_rewards_campaign' | translate}}</span>
              <span class="typography-body-l-regular text-center">{{'myrewards.your_profile_does_not_achieve_requirements' | translate}}</span>
              <span class="typography-body-l-regular mb-2">{{'myrewards.dont_lose_this_opportunity' | translate}}</span>

              <app-button [ghost]="true" (onClick)="this.sendEmail()">
                <div class="flex flex-row gap-2 items-center">

              <svg width="12" height="18" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M1.08333 10.3148C0.772222 10.3148 0.514 10.2121 0.308667 10.0068C0.102889 9.801 0 9.54256 0 9.23145V2.06478C0 1.75367 0.102889 1.49545 0.308667 1.29011C0.514 1.08433 0.772222 0.981445 1.08333 0.981445H10.9167C11.2278 0.981445 11.4862 1.08433 11.692 1.29011C11.8973 1.49545 12 1.75367 12 2.06478V9.23145C12 9.54256 11.8973 9.801 11.692 10.0068C11.4862 10.2121 11.2278 10.3148 10.9167 10.3148H1.08333ZM6 5.73145L0.666667 2.23145V9.23145C0.666667 9.35367 0.705556 9.45367 0.783333 9.53145C0.861111 9.60922 0.961111 9.64811 1.08333 9.64811H10.9167C11.0389 9.64811 11.1389 9.60922 11.2167 9.53145C11.2944 9.45367 11.3333 9.35367 11.3333 9.23145V2.23145L6 5.73145ZM6 4.98145L11.1333 1.64811H0.866667L6 4.98145ZM0.666667 2.23145V1.64811V9.23145C0.666667 9.35367 0.705556 9.45367 0.783333 9.53145C0.861111 9.60922 0.961111 9.64811 1.08333 9.64811H0.666667V9.23145V2.23145Z"
                        fill="#232323"
                    />
                </svg><span class="typography-body-s-light" >{{this.accountOwnerEmail}}</span>

              </div>
              </app-button>

            </div>
    </ng-container>
  </div>
</div>

